import React from "react";


export default function NoImageFoundDocument() {
    return (
        <div
            style={{
                marginRight: "-3.5vh",
                marginLeft: "0vh",
                width: "17em",
            }}
        >
            <div
                className="UploadImageCmp"
                style={{ textAlign: "center", marginLeft: "-10px" , alignItems: "center",
                    display: "flex"}}
            >
                <>
                    <a target="_blank" href="/images/noImageFound.svg">
                        <img
                            src="/images/noImageFound.svg"
                            alt="Forest"
                            className="uploadImage verticalImageloadDocument "
                            style={{ marginLeft: "-10px" }}
                        />
                    </a>
                </>
            </div>
        </div>
    );
}
